"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
exports.Page = (props) => {
    const { children } = props, containerProps = __rest(props, ["children"]);
    return (react_1.default.createElement("div", { className: 'page' },
        react_1.default.createElement(core_1.Container, Object.assign({ maxWidth: 'xl' }, containerProps), children)));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9sYXlvdXQvUGFnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxrREFHaUU7QUFDakUsNENBRzZFO0FBTWhFLFFBQUEsSUFBSSxHQUE2QixDQUFDLEtBQVksRUFBRSxFQUFFO0lBQzNELE1BQU0sRUFDRixRQUFRLEtBRVIsS0FBSyxFQURGLGNBQWMsVUFDakIsS0FBSyxFQUhILFlBR0wsQ0FBUSxDQUFDO0lBRVYsT0FBTyxDQUNILHVDQUFLLFNBQVMsRUFBQyxNQUFNO1FBQ2pCLDhCQUFDLGdCQUFTLGtCQUFDLFFBQVEsRUFBQyxJQUFJLElBQUssY0FBYyxHQUNyQyxRQUFRLENBQ0YsQ0FDVixDQUNULENBQUM7QUFDTixDQUFDLENBQUMifQ==